module.exports = __webpack_public_path__ + "img/36a4b31.png";